import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGmp, selectGmpBoardRows } from '../store/slices/gmpSlice';
import { fetchSubscriptionSummary, selectSubscriptionRows } from '../store/slices/subscriptionSlice';
import { buildTickerItems, countLiveIssues } from '../utils/tickerFeed';

const FEED_MAX_AGE_MS = 60000;

/**
 * Live IPO quotes shared by the ticker tape and the landing hero:
 * GET /api/market/gmp + GET /api/market/subscription, reused when fresh.
 */
export const useLiveIpoFeed = () => {
  const dispatch = useDispatch();
  const gmpRows = useSelector(selectGmpBoardRows);
  const subscriptionRows = useSelector(selectSubscriptionRows);
  const gmpStatus = useSelector((state) => state.gmp.status);

  useEffect(() => {
    dispatch(fetchGmp({ maxAgeMs: FEED_MAX_AGE_MS }));
    dispatch(fetchSubscriptionSummary({ maxAgeMs: FEED_MAX_AGE_MS }));
  }, [dispatch]);

  const items = useMemo(() => buildTickerItems({ gmpRows, subscriptionRows }), [gmpRows, subscriptionRows]);
  const counts = useMemo(() => countLiveIssues(gmpRows), [gmpRows]);

  return {
    items,
    counts,
    loading: !items.length && (gmpStatus === 'idle' || gmpStatus === 'loading'),
  };
};

export default useLiveIpoFeed;
